import './header';
import './cookie-info';
import { onAgeChecked } from './age-check';
import { onSetPreferenceImmediate } from './alcohol-preference';

onSetPreferenceImmediate(({ willNavigate }) => {
	if (willNavigate) {
		const ageCheckElements = document.querySelectorAll<HTMLElement>(
			'[data-age-check] > *',
		);
		ageCheckElements.forEach((element) => (element.style.opacity = '0'));
	}
});

document.querySelectorAll('[data-go-back]').forEach((link) => {
	link.addEventListener('click', (ev) => {
		ev.preventDefault();
		history.back();
	});
});

const isiOSSafari = () => {
	// https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari/29696509#29696509
	var ua = window.navigator.userAgent;
	var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	var webkit = !!ua.match(/WebKit/i);
	var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

	return iOSSafari;
};

if (isiOSSafari()) {
	const setHeaderHeight = () => {
		if (window.innerWidth > window.innerHeight) return;
		document.documentElement.style.setProperty(
			'--full-height',
			`${window.innerHeight}px`,
		);
	};

	setHeaderHeight();
}

/**
 * Animate cover sections
 */

document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll<HTMLElement>(
		'[data-class-when-visible]',
	);
	els.forEach((el) => {
		const className = el.getAttribute('data-class-when-visible');
		if (!className) return;

		onAgeChecked(() => {
			const observer = new IntersectionObserver(
				(entries) => {
					if (entries.some((entry) => entry.isIntersecting)) {
						observer.unobserve(el);
						el.classList.add(className);
					}
				},
				{
					threshold: 0.5,
					rootMargin: '0px',
				},
			);
			observer.observe(el);
		});
	});
});

/**
 * Animate gallery collage blocks
 */

document.addEventListener('DOMContentLoaded', () => {
	const els = document.querySelectorAll<HTMLElement>(
		'.wp-block-gallery.is-style-collage',
	);
	els.forEach((el) => {
		el.classList.add('animated');

		onAgeChecked(() => {
			const observer = new IntersectionObserver(
				(entries) => {
					if (entries.some((entry) => entry.isIntersecting)) {
						observer.unobserve(el);
						el.classList.add('animated--in');
					}
				},
				{
					threshold: 0.5,
					rootMargin: '0px',
				},
			);
			observer.observe(el);
		});
	});
});
